const _excluded = ["type"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import { useMemo } from 'react';
import { get } from 'lodash-es';
export let SortFieldType = /*#__PURE__*/function (SortFieldType) {
  SortFieldType["String"] = "string";
  SortFieldType["Number"] = "number";
  SortFieldType["Date"] = "date";
  return SortFieldType;
}({});
export let SortDirection = /*#__PURE__*/function (SortDirection) {
  SortDirection["Asc"] = "asc";
  SortDirection["Desc"] = "desc";
  return SortDirection;
}({});
const sortByString = (a, b) => {
  const valueA = a.toLowerCase();
  const valueB = b.toLowerCase();
  if (valueA < valueB) {
    return -1;
  }
  if (valueA > valueB) {
    return 1;
  }
  return 0;
};
const sortByNumberOrDate = (a, b) => {
  if (a < b) {
    return -1;
  }
  if (a > b) {
    return 1;
  }
  return 0;
};
export const filterAndSortData = _ref => {
  let {
    data,
    columnDefs,
    filter,
    sort
  } = _ref;
  let results = data !== null && data !== void 0 ? data : [];
  Object.entries(filter !== null && filter !== void 0 ? filter : {}).forEach(_ref2 => {
    let [key, {
      search
    }] = _ref2;
    results = results.filter(item => {
      var _itemValue;
      const searchValue = search.trim().toLowerCase();
      const data = columnDefs[key];
      let itemValue;
      if (!data) {
        return true;
      }
      if (data.getter === 'value') {
        itemValue = data.getValue(item);
      } else {
        itemValue = get(item, data.path);
      }
      return (_itemValue = itemValue) === null || _itemValue === void 0 ? void 0 : _itemValue.toString().toLowerCase().includes(searchValue);
    });
  });
  Object.entries(sort !== null && sort !== void 0 ? sort : {}).forEach(_ref3 => {
    let [key, {
      direction
    }] = _ref3;
    results.sort((a, b) => {
      const _columnDefs$key = columnDefs[key],
        {
          type
        } = _columnDefs$key,
        data = _objectWithoutProperties(_columnDefs$key, _excluded);
      let aVal;
      let bVal;
      if (data.getter === 'value') {
        aVal = data.getValue(a);
        bVal = data.getValue(b);
      } else {
        aVal = get(a, data.path);
        bVal = get(b, data.path);
      }
      if (type === SortFieldType.String && typeof aVal === 'string' && typeof bVal === 'string') {
        return direction === SortDirection.Asc ? sortByString(aVal, bVal) : sortByString(bVal, aVal);
      } else if ((type === SortFieldType.Number || type === SortFieldType.Date) && typeof aVal === 'number' && typeof bVal === 'number' || aVal instanceof Date && bVal instanceof Date) {
        return direction === SortDirection.Asc ? sortByNumberOrDate(aVal, bVal) : sortByNumberOrDate(bVal, aVal);
      }
      return 0;
    });
  });
  return results;
};
export const useFilterAndSortData = _ref4 => {
  let {
    data,
    columnDefs,
    filter,
    sort
  } = _ref4;
  const filteredData = useMemo(() => filterAndSortData({
    data,
    columnDefs,
    filter,
    sort
  }), [data, columnDefs, filter, sort]);
  return {
    data: filteredData
  };
};